"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _utils = require("../../utils");
var _Icon = require("../Icon");
var _excluded = ["name", "id", "wrapperStyles", "inputStyles", "checkboxStyles", "labelStyles", "type", "children", "onBlur", "errorAlertStyles"]; // Need explicit import to work in Storybook
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function CheckboxGroup(_ref) {
  var children = _ref.children,
    value = _ref.value,
    disabled = _ref.disabled,
    name = _ref.name,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange;
  var childArray = (0, _react.useMemo)(function () {
    return _react.default.Children.toArray(children);
  }, [children]);
  var handleChange = function handleChange(e) {
    var _e$target = e.target,
      val = _e$target.value,
      checked = _e$target.checked;
    var values = value ? (0, _lodash.cloneDeep)(value) : [];
    if (checked) {
      values.push(val);
      values = (0, _lodash.uniq)(values);
    } else {
      values = (0, _lodash.filter)(values, function (v) {
        return v !== val;
      });
    }
    onChange(values);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, childArray.map(function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      name: name,
      checked: value === null || value === void 0 ? void 0 : value.includes(child.props.value),
      disabled: disabled,
      onChange: handleChange
    });
  }));
}
var Checkbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var name = _ref2.name,
    inputId = _ref2.id,
    wrapperStyles = _ref2.wrapperStyles,
    inputStyles = _ref2.inputStyles,
    checkboxStyles = _ref2.checkboxStyles,
    labelStyles = _ref2.labelStyles,
    type = _ref2.type,
    children = _ref2.children,
    _ref2$onBlur = _ref2.onBlur,
    onBlur = _ref2$onBlur === void 0 ? _lodash.noop : _ref2$onBlur,
    errorAlertStyles = _ref2.errorAlertStyles,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useInputValidation = (0, _utils.useInputValidation)(props),
    checked = _useInputValidation.checked,
    error = _useInputValidation.error,
    validateOnBlur = _useInputValidation.validateOnBlur;
  var id = (0, _utils.useUniqueHtmlId)("checkbox-".concat(name));
  var handleBlur = function handleBlur(e) {
    validateOnBlur();
    onBlur(e);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('checkbox-wrapper relative', wrapperStyles)
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    name: name,
    id: inputId || id,
    type: "checkbox",
    ref: ref,
    onBlur: handleBlur,
    className: (0, _classnames.default)('peer checkbox-peer', 'opacity-0 border-none absolute', 'cursor-pointer disabled:cursor-not-allowed', inputStyles)
  }, props, {
    checked: checked,
    form: undefined
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('checkbox', type === 'light' ? 'checkbox-light' : 'checkbox-dark', checkboxStyles)
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "check-heavy-16"
  })), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: inputId || id,
    className: (0, _classnames.default)('checkbox-label', (0, _lodash.isString)(children) && 'tw-body-sm-regular', labelStyles)
  }, children)), error && /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)('tw-caption-regular text-alertred-60', errorAlertStyles)
  }, error));
});
var CheckboxNamespace = Object.assign(Checkbox, {
  Group: CheckboxGroup
});
exports.Checkbox = CheckboxNamespace;